import { useState, useEffect, useRef } from "react";
import img1 from "./Images/rivera2.jpeg";
import img2 from "./Images/rivera3.jpeg";
import img3 from "./Images/rivera4.jpeg";
// import Navbar from "../HomePage/Navbar";
const NAV_LINKS = [
  "Overview",
  "Highlights",
  "Amenities",
  "Floor Plans",
  "Gallery",
  "Contact",
];

const VILLAS = [
  {
    name: "SOL VILLA",
    area: "3,450 sq.ft.",
    icon: "☀️",
    tag: "Energetic",
    desc: "Sol channels the sun's vibrant energy with open, modern luxury. Featuring multiple floors with intelligent space planning, perfect for those who embrace dynamic living.",
    floors: "Ground, First & Second Floor",
    highlights: [
      "Sun-infused Open Interiors",
      "3D Floor Plans Available",
      "Premium Finishes",
      "Modern Luxury Design",
    ],
  },
  {
    name: "LUNA VILLA",
    area: "3,490 sq.ft.",
    icon: "🌙",
    tag: "Serene",
    desc: "Luna reflects the moon's serene elegance, offering a calm and refined retreat. Thoughtfully designed with sophisticated layouts for the discerning homeowner.",
    floors: "Ground, First & Second Floor",
    highlights: [
      "Serene Elegant Spaces",
      "3D Floor Plans Available",
      "Premium Finishes",
      "Timeless Sophistication",
    ],
  },
];

const AMENITIES = [
  { icon: "🏋️", label: "Outdoor Gym" },
  { icon: "🌊", label: "Lily Pond" },
  { icon: "⛳", label: "Mini Golf" },
  { icon: "🧘", label: "Yoga Pavilion" },
  { icon: "🌿", label: "Signature Sanctuaries" },
  { icon: "⛹️‍♂️", label: "Basketball Court" },
  { icon: "👥", label: "Social Square" },
  { icon: "🥅", label: "Futsal Court" },
  { icon: "🏓", label: "Pickleball Court" },
  { icon: "🌇", label: "Open Terrace" },
  { icon: "🛝", label: "Kids' Play Area" },
  { icon: "🚴", label: "Cycling Track" },
  { icon: "🏡", label: "Backyard" },
  { icon: "🌳", label: "Botanical Walk" },
  { icon: "🏏", label: "Box Cricket" },
  { icon: "🚗", label: "Valet Parking" },
];

const GALLERY_IMGS = [img1, img2, img3];

const GALLERY_LABELS = [
  "Grand Exterior",
  "Living Spaces",
  "Luxury Interiors",
  "Community Life",
];

function useIntersect(threshold = 0.15) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) setVisible(true);
      },
      { threshold },
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
}

function FadeIn({ children, delay = 0, className = "" }) {
  const [ref, visible] = useIntersect();
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(32px)",
        transition: `opacity 0.7s ease ${delay}s, transform 0.7s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
}

export default function RiveraEdition() {
  const [activeNav, setActiveNav] = useState("Overview");
  const [galleryIdx, setGalleryIdx] = useState(0);
  const [navScrolled, setNavScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setNavScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const timer = setInterval(
      () => setGalleryIdx((i) => (i + 1) % GALLERY_IMGS.length),
      4000,
    );
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="min-h-screen bg-white font-sans"
      style={{ fontFamily: "'Georgia', serif" }}
    >
      {/* NAV */}
      {/* <Navbar /> */}

      {/* HERO */}
      <div className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden ">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${GALLERY_IMGS[galleryIdx]})`,
            transition: "background-image 1s ease",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" />

        {/* Decorative border */}

        <div className="absolute inset-6 border border-white/20 pointer-events-none hidden md:block" />
        <div className="absolute inset-8 border border-red-600/30 pointer-events-none hidden md:block" />

        <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
          <div className="inline-block border border-red-400/60 text-red-300 text-xs tracking-[0.4em] px-6 py-2 mb-6 uppercase">
            Bengaluru · Ahmedabad
          </div>
          <h1
            className="text-5xl sm:text-6xl md:text-8xl font-bold text-white leading-none mb-2"
            style={{ letterSpacing: "-0.02em", fontFamily: "'Georgia', serif" }}
          >
            RIVIERA UNO
          </h1>
          <h2
            className="text-3xl sm:text-4xl md:text-6xl font-light text-red-400 tracking-[0.2em] mb-6"
            style={{ fontFamily: "'Georgia', serif" }}
          >
            EDITION
          </h2>
          <p className="text-white/70 text-base md:text-lg tracking-widest max-w-xl mx-auto mb-10 font-light">
            Refined Living · Sun & Moon Inspired · Timeless Sophistication
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#brochure"
              className="px-8 py-3.5 bg-red-700 hover:bg-red-600 text-white font-bold tracking-widest text-sm transition-all rounded shadow-2xl shadow-red-900/50"
            >
              DOWNLOAD BROCHURE
            </a>
            <a
              href="#overview"
              className="px-8 py-3.5 border border-white/40 hover:border-white text-white font-semibold tracking-widest text-sm transition-all rounded"
            >
              EXPLORE PROJECT
            </a>
          </div>
        </div>

        {/* Gallery dots */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2">
          {GALLERY_IMGS.map((_, i) => (
            <button
              key={i}
              onClick={() => setGalleryIdx(i)}
              className={`w-2 h-2 rounded-full transition-all ${i === galleryIdx ? "bg-red-500 w-6" : "bg-white/40"}`}
            />
          ))}
        </div>
      </div>

      {/* QUICK STATS BAR */}
      <div className="bg-red-700 py-4 px-4">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { label: "LOCATION", value: "Whitefield" },
            { label: "SPREAD", value: "~68 Acres" },
            { label: "HOMES", value: "~250+" },
            { label: "PROPERTIES ON LEASE", value: "120+" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-white font-bold text-xl md:text-2xl">
                {s.value}
              </div>
              <div className="text-red-200 text-xs tracking-widest mt-0.5">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* OVERVIEW */}
      <section id="overview" className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <FadeIn>
            <div className="text-center mb-16">
              <div className="text-red-600 text-xs tracking-[0.4em] mb-3 uppercase">
                About The Project
              </div>
              <h2
                className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
                style={{ fontFamily: "'Georgia', serif" }}
              >
                Leading the Legacy, <br className="hidden md:block" />
                <span className="text-red-700">Now by Redefining Luxury</span>
              </h2>
              <div className="w-16 h-0.5 bg-red-600 mx-auto mt-4 mb-6" />
              <p className="text-gray-500 max-w-2xl mx-auto leading-relaxed text-lg">
                Riviera offers exclusive homes rooted in five decades of
                expertise. Set in prime locations, it reflects refined living
                and legacy. Riviera Uno features premium 4 BHK villas. Blending
                Vastu design with modern luxury and elegance.
              </p>
            </div>
          </FadeIn>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                icon: "🏰",
                title: "Sun-Moon Inspired Architecture",
                desc: "Sol channels the sun’s vibrant energy with open, modern luxury—while Luna reflects the moon’s serene elegance, offering a calm, refined retreat.",
              },
              {
                icon: "🌿",
                title: "Central Green Spine",
                desc: "A tranquil Healing Trail designed to refresh your mind and body, offering a peaceful escape to reconnect with nature.",
              },
              {
                icon: "🏆",
                title: "Legacy Developer",
                desc: "Founded in 1971 by Mr. Rampurshottam Goyal, Goyal & Co. and Hariyana Group have redefined Bengaluru’s skyline—now elevating luxury living with Riviera.",
              },
            ].map((c, i) => (
              <FadeIn key={c.title} delay={i * 0.1}>
                <div className="group p-8 border border-gray-100 hover:border-red-200 rounded-xl hover:shadow-xl transition-all bg-white">
                  <div className="text-4xl mb-5">{c.icon}</div>
                  <h3
                    className="font-bold text-gray-900 text-lg mb-3 group-hover:text-red-700 transition-colors"
                    style={{ fontFamily: "'Georgia', serif" }}
                  >
                    {c.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    {c.desc}
                  </p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* GALLERY ROW */}
      <section className="py-4 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-3">
          {GALLERY_IMGS.map((img, i) => (
            <FadeIn key={i} delay={i * 0.08}>
              <div className="relative overflow-hidden rounded-lg aspect-video md:aspect-square group cursor-pointer">
                <img
                  src={img}
                  alt={GALLERY_LABELS[i]}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-3 left-3 text-white text-xs font-semibold tracking-widest">
                  {GALLERY_LABELS[i].toUpperCase()}
                </div>
                <div className="absolute top-3 right-3 w-6 h-6 rounded-full bg-red-700/80 flex items-center justify-center text-white text-xs">
                  {i + 1}
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </section>

      {/* FLOOR PLANS */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <FadeIn>
            <div className="text-center mb-14">
              <div className="text-red-600 text-xs tracking-[0.4em] mb-3 uppercase">
                Floor Plans
              </div>
              <h2
                className="text-4xl md:text-5xl font-bold text-gray-900"
                style={{ fontFamily: "'Georgia', serif" }}
              >
                Find Your <span className="text-red-700">Perfect Home</span>
              </h2>
              <div className="w-16 h-0.5 bg-red-600 mx-auto mt-4" />
            </div>
          </FadeIn>

          <div className="grid md:grid-cols-2 gap-8">
            {VILLAS.map((villa, i) => (
              <FadeIn key={villa.name} delay={i * 0.1}>
                <div className="group relative border-2 border-gray-100 hover:border-red-400 rounded-3xl p-8 hover:shadow-2xl transition-all bg-gradient-to-br from-white to-gray-50 overflow-hidden">
                  <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-red-700 to-red-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />

                  <div className="flex items-start justify-between mb-6">
                    <span className="text-5xl">{villa.icon}</span>
                    <span className="text-xs font-bold tracking-widest text-red-600 bg-red-100 border border-red-300 px-4 py-2 rounded-full uppercase">
                      {villa.tag}
                    </span>
                  </div>

                  <h3
                    className="font-bold text-gray-900 text-2xl mb-2"
                    style={{ fontFamily: "'Georgia', serif" }}
                  >
                    {villa.name}
                  </h3>

                  <div className="text-red-700 font-bold text-lg mb-1 tracking-wide">
                    {villa.area}
                  </div>

                  <div className="text-gray-500 text-sm font-semibold mb-4 tracking-widest">
                    {villa.floors}
                  </div>

                  <p className="text-gray-600 text-sm leading-relaxed mb-6">
                    {villa.desc}
                  </p>

                  <div className="mb-6 p-4 bg-white rounded-lg border border-gray-200">
                    <div className="text-xs font-bold text-gray-700 tracking-widest mb-3 uppercase">
                      Key Highlights
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                      {villa.highlights.map((highlight, idx) => (
                        <div key={idx} className="flex items-start gap-2">
                          <span className="text-red-600 font-bold text-lg leading-none mt-0.5">
                            •
                          </span>
                          <span className="text-gray-700 text-xs">
                            {highlight}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <button className="w-full py-3 px-4 bg-red-700 hover:bg-red-800 text-white font-bold tracking-widest text-xs rounded-lg transition-all flex items-center justify-center gap-2 group">
                    VIEW FLOOR PLAN{" "}
                    <span className="text-base group-hover:translate-x-1 transition-transform">
                      →
                    </span>
                  </button>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* HIGHLIGHTS BANNER */}
      <section className="py-16 px-4 bg-red-700 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-64 h-64 border border-white rounded-full -translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 right-0 w-96 h-96 border border-white rounded-full translate-x-1/3 translate-y-1/3" />
        </div>
        <div className="max-w-7xl mx-auto relative z-10">
          <FadeIn>
            <div className="text-center mb-12">
              <div className="text-red-200 text-xs tracking-[0.4em] mb-3 uppercase">
                Why Choose Edition
              </div>
              <h2
                className="text-3xl md:text-4xl font-bold text-white"
                style={{ fontFamily: "'Georgia', serif" }}
              >
                Crafted For The Discerning Few
              </h2>
            </div>
          </FadeIn>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6">
            {[
              {
                icon: "🚇",
                title: "Metro Connected",
                desc: "Prime Whitefield address with direct metro and highway access",
              },
              {
                icon: "🧿",
                title: "Vaastu Compliant",
                desc: "All layouts designed in accordance with Vaastu Shastra principles",
              },
              {
                icon: "📈",
                title: "Strong ROI",
                desc: "High investment potential in Bengaluru's fastest-growing corridor",
              },
              {
                icon: "🏅",
                title: "Trusted Brand",
                desc: "Legacy developer with a proven record of landmark deliveries",
              },
            ].map((h, i) => (
              <FadeIn key={h.title} delay={i * 0.1}>
                <div className="text-center p-5">
                  <div className="text-4xl mb-3">{h.icon}</div>
                  <h3 className="font-bold text-white text-base mb-2">
                    {h.title}
                  </h3>
                  <p className="text-red-100 text-sm leading-relaxed">
                    {h.desc}
                  </p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* AMENITIES */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <FadeIn>
            <div className="text-center mb-14">
              <div className="text-red-600 text-xs tracking-[0.4em] mb-3 uppercase">
                Lifestyle Amenities
              </div>
              <h2
                className="text-4xl md:text-5xl font-bold text-gray-900"
                style={{ fontFamily: "'Georgia', serif" }}
              >
                150+ Curated <span className="text-red-700">Amenities</span>
              </h2>
              <div className="w-16 h-0.5 bg-red-600 mx-auto mt-4 mb-4" />
              <p className="text-gray-500 max-w-xl mx-auto">
                A curated world of amenities inspired by the sun’s vitality and
                the moon’s serenity—crafted for elevated living.
              </p>
            </div>
          </FadeIn>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
            {AMENITIES.map((a, i) => (
              <FadeIn key={a.label} delay={i * 0.04}>
                <div className="group bg-white hover:bg-red-700 border border-gray-100 hover:border-red-700 rounded-xl p-4 text-center transition-all duration-300 cursor-default">
                  <div className="text-2xl mb-2">{a.icon}</div>
                  <div className="text-gray-600 group-hover:text-white text-xs font-semibold tracking-wide leading-tight transition-colors">
                    {a.label}
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* LOCATION */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <FadeIn>
            <div>
              <div className="text-red-600 text-xs tracking-[0.4em] mb-3 uppercase">
                Prime Location
              </div>
              <h2
                className="text-4xl font-bold text-gray-900 mb-6"
                style={{ fontFamily: "'Georgia', serif" }}
              >
                Soukya Road,
                <br />
                <span className="text-red-700">Whitefield</span>
              </h2>
              <p className="text-gray-500 leading-relaxed mb-8">
                Situated in the heart of Whitefield — Bengaluru’s leading IT and
                lifestyle hub — Riviera Uno ensures seamless access to key
                destinations.
              </p>
              <div className="space-y-3">
                {[
                  "5 min to Whitefield (Kadugodi) Metro Station",
                  "10 min to ITPL & GR Tech Park",
                  "15 min to Nexus Shantiniketan & Phoenix Marketcity",
                  "20 min to major tech corridors like Bagmane & RMZ Infinity",
                  "Close to top schools, hospitals & everyday conveniences",
                ].map((item) => (
                  <div key={item} className="flex items-start gap-3">
                    <div className="w-5 h-5 rounded-full bg-red-700 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-white text-xs">✓</span>
                    </div>
                    <span className="text-gray-600 text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </FadeIn>
          <FadeIn delay={0.15}>
            <div className="bg-gray-100 rounded-2xl overflow-hidden h-80 md:h-96 flex items-center justify-center relative">
              <iframe
                title="Riviera Uno Edition Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.675445728627!2d77.7914595!3d12.992598399999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae0f00288ea161%3A0xa740e097b4365e1b!2sRiviera%20Uno%20-%20Goyal%20%26%20Co%20%7C%20Hariyana%20Group!5e0!3m2!1sen!2sin!4v1776598502667!5m2!1sen!2sin"
                className="w-full h-full border-0"
                allowFullScreen
                loading="lazy"
              />
              <div className="absolute top-4 left-4 bg-red-700 text-white text-xs font-bold tracking-widest px-3 py-1.5 rounded shadow-lg">
                📍 WHITEFIELD, BENGALURU
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* BROCHURE CTA */}
      <section
        id="brochure"
        className="py-24 px-4 bg-gray-900 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src={GALLERY_IMGS[1]}
            alt=""
            className="w-full h-full object-cover opacity-10"
          />
        </div>
        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <FadeIn>
            <div className="border border-white/10 rounded-3xl p-10 md:p-14 backdrop-blur-sm">
              <div className="text-red-400 text-xs tracking-[0.4em] mb-4 uppercase">
                Your Dream Home Awaits
              </div>
              <h2
                className="text-4xl md:text-5xl font-bold text-white mb-4"
                style={{ fontFamily: "'Georgia', serif" }}
              >
                Download the <span className="text-red-400">Brochure</span>
              </h2>
              <p className="text-white/60 mb-10 text-base leading-relaxed">
                Get comprehensive floor plans, amenity details, pricing
                insights, and everything you need to make your decision — all in
                one beautifully crafted document.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="#"
                  className="px-8 py-4 bg-red-700 hover:bg-red-600 text-white font-bold tracking-widest text-sm transition-all rounded-lg shadow-2xl shadow-red-900/50 flex items-center gap-2"
                  onClick={(e) => {
                    e.preventDefault();
                    alert(
                      "📄 Brochure download link would be here — connect your CRM or PDF asset.",
                    );
                  }}
                >
                  <span>📥</span> DOWNLOAD BROCHURE
                </a>
                <a
                  href="https://wa.me/message/MDG2ZSZNG6P6G1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 border border-white/30 hover:border-red-400 text-white hover:text-red-400 font-semibold tracking-widest text-sm transition-all rounded-lg flex items-center gap-2"
                >
                  <span>📋</span> SCHEDULE A VISIT / CONTACT
                </a>
              </div>
              <p className="text-white/30 text-xs mt-6 tracking-wide">
                RERA Registered · Riviera Uno Pvt. Ltd.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-red-800 py-8 px-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <div className="font-bold text-white tracking-widest text-sm">
              RIVIERA UNO EDITION
            </div>
            <div className="text-red-200 text-xs tracking-widest mt-0.5">
              Soukya Road · Whitefield · Bengaluru
            </div>
          </div>
          <div className="text-red-200 text-xs tracking-wide text-center">
            ©️ 2025 Riviera Uno Pvt. Ltd. All rights reserved. · RERA Registered
          </div>
          <div className="flex gap-4 text-red-200 text-xs">
            <a href="#" className="hover:text-white transition-colors">
              Privacy
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Terms
            </a>
            <a
              href="https://wa.me/message/MDG2ZSZNG6P6G1"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Contact
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}